import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Permit } from 'src/app/core/interfaces/permits/permit';
import { Project } from 'src/app/core/interfaces/production/project';
import { ApiService } from 'src/app/core/services/api/api.service';

@Component({
  selector: 'app-permit-counts-list',
  templateUrl: './permit-counts-list.component.html',
  styleUrls: ['./permit-counts-list.component.scss'],
})
export class PermitCountsListComponent implements OnInit {
  @Input() status: string;
  statusMessage: string;
  statusNumber: number;

  displayedColumns: string[] = [
    'projectId',
    'customerName',
    'jobaddress',
    'contractDate',
    'contractTotal',
    'projectTotal',
    'projectName',
    'foreman',
    'scheduledDate',
    'confirmedDate',
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  projectArray: Project[] = [];
  dataSource: MatTableDataSource<Project>;

  isLoading: boolean = true;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();
    // this.getProjects(this.status);
    this.route.paramMap.subscribe((params) => {
      this.status = params.get('status') as string;
      this.getProjects(this.status);
    });
  }

  getProjects(status: string) {
    this.dataSource = new MatTableDataSource();
    this.isLoading = true;

    if (status) {
      switch (status) {
        case 'permitsRequired':
          this.statusNumber = 0;
          this.statusMessage = 'Projects requiring permits';
          break;
        case 'permitsRequested':
          this.statusNumber = 1;
          this.statusMessage = 'Projects with requested permits';
          break;
        case 'permitsReceived':
          this.statusNumber = 2;
          this.statusMessage = 'Projects with recieved permits';
          break;
      }
    }

    if (this.statusNumber != undefined) {
      this.apiService.getProjectsByPermitStatus(this.statusNumber).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.projectArray = response;
          this.dataSource = new MatTableDataSource(this.projectArray);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        },
        error: (e) => {
          this.isLoading = false;
          console.error(e);
        },
      });
    }
  }

  goToProject(row: Permit) {
    this.router.navigate(['customers/' + row.customerId], {
      queryParams: {
        jobAddressId: row.jobAddressId,
        projectId: row.projectId,
        permit: true,
      },
    });
  }

  filterProjects(event: Event) {
    const filterString = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterString.trim().toLowerCase();
  }
}
